'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var styledComponents = require('./styled-components.js');

var ColoredMetricBar = function (_a) {
    var _b = _a.barSections, barSections = _b === void 0 ? [] : _b;
    var total = barSections.reduce(function (t, v) { return t + v.value; }, 0);
    var percentage = function (value) { return (value / total) * 100; };
    return (React__default.createElement(styledComponents.BarsContainer, null,
        React__default.createElement(core.Grid, { container: true }, barSections.map(function (section) { return (React__default.createElement(styledComponents.ColoredBarContainer, { "data-testid": 'colored-bar-container', width: percentage(section.value).toString(), key: section.value + "-" + section.color },
            React__default.createElement(styledComponents.ColoredBar, { color: section.color }))); }))));
};

module.exports = ColoredMetricBar;
